export var Text;

(function (Text) {
  function isText(value) {
    return value && typeof value === 'object' && typeof value.text === 'string';
  }

  Text.isText = isText;

  function validateText(value) {
    return isText(value) ? value : null;
  }

  Text.validateText = validateText;
})(Text || (Text = {}));